// import React from "react";
import "../bbCss/bb.scss";
import { Route, Routes } from "react-router-dom";
import BusinessThreeNavbar from "../../business/businessThree/businessThreeComponents/BusinessThreeNavbar";
import Navbar from "../../../default-components/Navbar";
import BlackberryHome from "../bbPages/BlackberryHome";
import GlobalRoute from "../../../global route/GlobalRoute";
import { useDocument } from "../../../firebase-files/hooks/useDocument";
import BlackberryFooter from "../bbComponents/BlackberryFooter";
import BlackberryAbout from "../bbPages/BlackberryAbout";

const BlackberryRoute = () => {
  const { document: navTypeDoc } = useDocument("settings", "navbarType");
  return (
    <>
      {navTypeDoc && navTypeDoc.activeNav == "FixNav" ? (
        <Navbar />
      ) : (
        <BusinessThreeNavbar />
      )}
      <Routes>
        <Route path="/" element={<BlackberryHome />} />
        <Route path="/about" element={<BlackberryAbout />} />
      </Routes>
      <GlobalRoute />
      <BlackberryFooter />
    </>
  );
};

export default BlackberryRoute;
